/**Dependencies */
import React from "react";

/**Components */
import { Form, Button } from "react-bootstrap";

/**Styles */
import "../styles/index.scss";

import chicaForm from "../images/chica-formulario.png";

export const FormContact = ({
  formValue1,
  formValue2,
  formValueName,
  formValueEmail,
  formValuePhone,
  formValueDate,
  nameLabel1,
  nameLabel2,
  handleChange,
  handleSubmit,
}) => {
  return (
    <>
      <Form onSubmit={handleSubmit} className="w-100">
        <div>
          <Form.Group controlId="formName" className="mb-3">
            <Form.Label className="text-light">{nameLabel1}</Form.Label>
            <Form.Control
              type="text"
              name="nameHotel"
              value={formValue1}
              onChange={handleChange}
              disabled
              className="bg-gray rounded-0 text-light border-0"
              style={{ fontSize: "14px" }}
              required
            />
          </Form.Group>
          <br />
          <Form.Group controlId="formEmail" className="mb-3">
            <Form.Label className="text-light">{nameLabel2}</Form.Label>
            <Form.Control
              type="text"
              name="nameHab"
              value={formValue2}
              disabled
              onChange={handleChange}
              className="bg-gray rounded-0 text-light border-0"
              style={{ fontSize: "14px" }}
              required
            />
          </Form.Group>
          <br />
          <Form.Group controlId="formFecha">
            <Form.Label className="text-light">Nombre completo</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formValueName}
              onChange={handleChange}
              className="bg-gray rounded-0 text-light border-0"
              style={{ fontSize: "14px" }}
              required
            />
          </Form.Group>
          <br />
          <Form.Group controlId="formPhone" className="mb-3">
            <Form.Label className="text-light">Correo</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formValueEmail}
              onChange={handleChange}
              className="bg-gray rounded-0 text-light border-0"
              style={{ fontSize: "14px" }}
              required
            />
          </Form.Group>
          <br />
          <Form.Group controlId="formPhone" className="mb-3">
            <Form.Label className="text-light">Teléfono</Form.Label>
            <Form.Control
              type="text"
              name="phone"
              maxLength={10}
              value={formValuePhone}
              onChange={handleChange}
              className="bg-gray rounded-0 text-light border-0"
              style={{ fontSize: "14px" }}
              required
            />
          </Form.Group>
          <br />
          <Form.Group controlId="formPhone" className="mb-3">
            <Form.Label className="text-light">Fechas</Form.Label>
            <Form.Control
              type="date"
              name="date"
              value={formValueDate}
              onChange={handleChange}
              className="bg-gray rounded-0 text-light border-0"
              style={{ fontSize: "14px" }}
              min={new Date().toJSON().slice(0, 10)}
              required
            />
          </Form.Group>

          <div className="d-flex justify-content-center pt-5">
            <Button
              type="submit"
              className="btn-modal-contact text-white"
              style={{ width: "30%", fontSize: "20px" }}
            >
              Enviar
            </Button>
          </div>
        </div>
      </Form>
      <div
        className="d-lg-flex d-none position-relative"
        style={{ top: "1rem" }}
      >
        <img src={chicaForm} className="w-100 h-auto" alt="" />
      </div>
    </>
  );
};
